module.exports = __webpack_public_path__ + "img/about-skinxs-animation.6ef8447e.gif";